export default {
  settings: 'Configuración',
  storefront: 'Tienda',
  media: 'Medios',
  style: 'Estilo',
  scripts: 'Scripts',
  no_google_place: {
    title: 'La empresa no está conectada a ninguna ubicación de Google',
    description: 'Por favor, conecta la empresa a una ubicación de Google',
  },
};
